import React from 'react';
import { Player } from 'video-react';
import "../../../node_modules/video-react/dist/video-react.css";
import WT1 from '../images/Projects/WorkTables/WorkTables.jpg';
import WT2 from '../images/Projects/WorkTables/WorkTables1.jpg';
import WT3 from '../images/Projects/WorkTables/WorkTables2.jpg';
import D1 from '../images/Projects/Desk/Desk1.jpeg';
import D2 from '../images/Projects/Desk/Desk2.jpeg';
import SR5 from '../images/Projects/ShoeRack/ShoeRack5.jpg';
import DB5 from '../images/Projects/Dogs/DogBed4.jpg';
import DS3 from '../images/Projects/DogStairs/DogStairs3.jpg';
import RS1 from '../images/Projects/RatchetStrap/Roller1.jpg';
import RS2 from '../images/Projects/RatchetStrap/Roller2.jpg';
import RS3 from '../images/Projects/RatchetStrap/Roller3.jpg';
import RS4 from '../images/Projects/RatchetStrap/Roller4.jpg';
import SW1 from '../images/Projects/SolidworksDesigns/BedFrame.jpg';
import SW2 from '../images/Projects/SolidworksDesigns/CoffeeTable.jpg';
import SW3 from '../images/Projects/SolidworksDesigns/Engine.jpg';
import SW4 from '../images/Projects/SolidworksDesigns/Engine1.m4v';
import C1 from '../images/Projects/Cats/Cat1.jpg';
import C3 from '../images/Projects/Cats/Cat4.jpg';
import M1 from '../images/Projects/Misc/ShiftKnob.jpg';
import M2 from '../images/Projects/Misc/ShiftKnob1.jpg';
import M3 from '../images/Projects/Misc/MetalThing.jpg';
import M4 from '../images/Projects/Misc/Pointy.jpg';
import M5 from '../images/Projects/Misc/ToolHolder.jpg';
import M6 from '../images/Projects/Misc/PictureFrame.jpg';
import M7 from '../images/Projects/Misc/PencilBox.jpg';
import M8 from '../images/Projects/Misc/IMG_6131.JPG';
import DH1 from '../images/Projects/DoorHandle/DoorHandle1.JPG';
import DH4 from '../images/Projects/DoorHandle/DoorHandle4.jpg';
import ShoeRackMore from '../PhotoShow/ShoeRackMore';
import DogBedMore from '../PhotoShow/DogBedMore';
import DogStairsMore from '../PhotoShow/DogStairsMore';
import CatsMore from '../PhotoShow/CatsMore';

import { column, row, imageSeparator, seeMoreButton, halfImage } from '../styles';


export default class Projects extends React.Component {

    constructor() {
        super();
        this.state = {
            shoeRackMoreShow: false,
            dogStairsMoreShow: false,
            dogBedsMoreShow: false,
            catsMoreShow: false,
        }
    }

    render() {
        return (
            <div style={column}>
                <h4 style={{margin: '0'}}>**All projects listed on this page were designed, drafted, and created by me unless otherwise noted**</h4>
                <h2 style={{margin:0, width:'77%'}}>Not Pictured</h2>
                <p style={{margin:0, width:'77%'}}>- Built and Tuned Anet A8 3D printer from kit</p>
                <p style={{margin:0, width:'77%'}}>- Designed and Printed a filament case, filament tube, brackets for a dehydrator to work with my 3D printer for TPU material, brackets for the 3D printer</p>
                <p style={{margin:0, width:'77%'}}>- Designed Custom Vice Jaws in Solidworks, 3D printed at home</p>
                <p style={{margin:0, width:'77%'}}>- Dog Collar Tag, Purse Hanger for my wife</p>
                <p style={{margin:0, width:'77%'}}>- Woodworking Compass</p>


                <div style={{ width: '77%', color: 'white' }}>
                    <hr></hr>
                </div>

                <h2>Custom 3D Printed Sliding Door Handle</h2>
                <div style={row}>
                    <img style={halfImage} src={DH1} alt="WT1" />
                    <div style={imageSeparator}></div>
                    <img style={halfImage} src={DH4} alt="WT2" />
                </div>
                <div style={{display:"flex", width:'77%', justifyContent:"center", textAlign:"center", marginBottom:"20px"}}>
                    <p style={{margin:"0px", width:"35%"}}>My wife has been working from home since the covid-19 pandemic, and mentioned that it was difficult for her to get up
                    from her chair to let our two dogs outside all the time without getting distracted from work. I came up with this sliding door handle. I measured the door with 
                    a caliper and drafted it up in SolidWorks, then 3D printed it at home.</p>
                    <div style={imageSeparator}></div>
                    <p style={{margin:"0px", width:"35%"}}>The print fits perfectly on our sliding back door, and it works better than expected. My wife can open the door from her office desk
                    without getting too off-task from her work. It's fascinating how such a quick project can make such a huge difference in time-efficiency with the right design.</p>                    
                </div>

                <div style={{ width: '77%', color: 'white' }}>
                    <hr></hr>
                </div>

                <h2>Mobile Work Benches with Miter Stand</h2>
                <div style={row}>
                    <img style={halfImage} src={WT1} alt="WT1" />
                    <div style={imageSeparator}></div>
                    <img style={halfImage} src={WT2} alt="WT2" />
                </div>
                <div style={{display:"flex", width:'77%', justifyContent:"center", textAlign:"center", marginBottom:"20px"}}>
                    <p style={{margin:"0px", width:"35%"}}>Designed in SolidWorks to figure out shapes and jointery.</p>
                    <div style={imageSeparator}></div>
                    <p style={{margin:"0px", width:"35%"}}>Color coded sketch to set up a cut list for the frames.</p>                    
                </div>
                <div style={row}>
                    <img style={halfImage} src={WT3} alt="WT3" />
                </div>
                <div style={{display:"flex", width:'77%', justifyContent:"center", textAlign:"center", marginBottom:"20px"}}>
                    <p style={{margin:"0px", width:"35%"}}>These benches turned out fantastic. I planned the height so that they work as outfeed tables for my table saw, as well as supports for my miter station. I have been using these benches for 2+ years and absolutely love them.</p>                   
                </div>

                <div style={{ width: '77%', color: 'white' }}>
                    <hr></hr>
                </div>
                
                <h2>Home Office Standing Desk </h2>
                <div style={row}>
                    <img style={halfImage} src={D1} alt="D1" />
                    <div style={imageSeparator}></div>
                    <img style={halfImage} src={D2} alt="D2" />
                </div>
                <div style={{display:"flex", width:'77%', justifyContent:"center", textAlign:"center", marginBottom:"20px"}}>
                    <p style={{margin:"0px", width:"35%"}}>The finished desk in place. Loving how it turned out. I started with scrap pine and 2"x4" studs.</p>
                    <div style={imageSeparator}></div>
                    <p style={{margin:"0px", width:"35%"}}>This desk frame is the first time I've tried half lap joints. They are simple enough, look great, and are very sturdy.</p>                    
                </div>

                <div style={{ width: '77%', color: 'white' }}>
                    <hr></hr>
                </div>
                
                <h2>Home Shoe Rack</h2>
                <div style={row}>
                    <img style={halfImage} src={SR5} alt="SR5" />
                </div>
                <div style={{display:"flex", width:'77%', justifyContent:"center", textAlign:"center", marginBottom:"20px"}}>
                    <p style={{margin:"0px", width:"35%"}}>Our mud room had no sense of organization for the longest time and it frustrated me. I saw a problem, and came up with a solution. This was the first project I have ever done with the goal of being "pretty" and not just functional, and it checks both boxes well.</p>                 
                </div>
                <div style={row}>
                    <button style={seeMoreButton} onClick={() => {
                            this.setState({shoeRackMoreShow: !this.state.shoeRackMoreShow});
                        }}>
                            Click to see more Shoe Rack pictures
                    </button>
                </div>
                {this.state.shoeRackMoreShow ? (
                    <>
                        <ShoeRackMore />
                        <button style={seeMoreButton} onClick={() => {
                            this.setState({ shoeRackMoreShow: !this.state.shoeRackMoreShow });
                        }}>
                            Close
                        </button>
                    </>)
                    : <></>}

                <div style={{ width: '77%', color: 'white' }}>
                    <hr></hr>
                </div>

                <h2>Miscellaneous Projects</h2>
                <div style={row}>
                    <img style={halfImage} src={M1} alt="M1" />
                    <div style={imageSeparator}></div>
                    <img style={halfImage} src={M2} alt="M2" />
                </div>
                <div style={{display:"flex", width:'77%', justifyContent:"center", textAlign:"center", marginBottom:"20px"}}>
                    <p style={{margin:"0px", width:"35%"}}>A custom shift knob I designed in high school.</p>
                    <div style={imageSeparator}></div>
                    <p style={{margin:"0px", width:"35%"}}>I cast this shift knob in aluminum at a later time.</p>                    
                </div>
                <div style={row}>
                    <img style={halfImage} src={M3} alt="M3" />
                    <div style={imageSeparator}></div>
                    <img style={halfImage} src={M4} alt="M4" />

                </div>
                <div style={{display:"flex", width:'77%', justifyContent:"center", textAlign:"center", marginBottom:"20px"}}>
                    <p style={{margin:"0px", width:"35%"}}>I learned a lot making this sheet metal tool box from scratch.</p>
                    <div style={imageSeparator}></div>
                    <p style={{margin:"0px", width:"35%"}}>A metal scribe I made in my Metallic Processes class.</p>                    
                </div>
                <div style={row}>
                    <img style={halfImage} src={M5} alt="M5" />
                    <div style={imageSeparator}></div>
                    <img style={halfImage} src={M6} alt="M6" />

                </div>
                <div style={{display:"flex", width:'77%', justifyContent:"center", textAlign:"center", marginBottom:"20px"}}>
                    <p style={{margin:"0px", width:"35%"}}>Made this drill station for my dad for Christmas.</p>
                    <div style={imageSeparator}></div>
                    <p style={{margin:"0px", width:"35%"}}>My first woodworking project ever. A shadow box.</p>                    
                </div>
                <div style={row}>
                    <img style={halfImage} src={M7} alt="M7" />
                    <div style={imageSeparator}></div>
                    <img style={halfImage} src={M8} alt="M8" />

                </div>
                <div style={{display:"flex", width:'77%', justifyContent:"center", textAlign:"center", marginBottom:"20px"}}>
                    <p style={{margin:"0px", width:"35%"}}>I didn't like having all my pens and pencils loose in my backpack and on my desk, so I designed and 3D printed this magnetic case for them.</p>
                    <div style={imageSeparator}></div>
                    <p style={{margin:"0px", width:"35%"}}>I made this floating picture frame for my wife. Had to start over several times as the acrylic shatters easily when drilling.</p>                    
                </div>

                <div style={{ width: '77%', color: 'white' }}>
                    <hr></hr>
                </div>
                
                <h2>Dog Beds</h2>
                <div style={row}>
                    <img style={halfImage} src={DB5} alt="DB5" />
                </div>
                <div style={{display:"flex", width:'77%', justifyContent:"center", textAlign:"center", marginBottom:"20px"}}>
                    <p style={{margin:"0px", width:"35%"}}>This dog bed turned out way too big, but I got a lot of great experience making it.</p>                 
                </div>
                <div style={row}>
                    <button style={seeMoreButton} onClick={() => {
                            this.setState({dogBedsMoreShow: !this.state.dogBedsMoreShow});
                        }}>
                            Click to see more Dog Bed pictures
                    </button>
                </div>
                {this.state.dogBedsMoreShow ? (
                    <>
                        <DogBedMore />
                        <button style={seeMoreButton} onClick={() => {
                            this.setState({ dogBedsMoreShow: !this.state.dogBedsMoreShow });
                        }}>
                            Close
                        </button>
                    </>)
                    : <></>}

                <div style={{ width: '77%', color: 'white' }}>
                    <hr></hr>
                </div>
                
                <h2>Dog Stairs</h2>
                <div style={row}>
                    <img style={halfImage} src={DS3} alt="DS3" />
                </div>
                <div style={{display:"flex", width:'77%', justifyContent:"center", textAlign:"center", marginBottom:"20px"}}>
                    <p style={{margin:"0px", width:"35%"}}>A dog breeder was in search of some small stairs she could train her puppies on. She and I discussed some design ideas, and this is what came of it. That's my big puppy Leonidas testing them out.</p>                  
                </div>
                <div style={row}>
                    <button style={seeMoreButton} onClick={() => {
                            this.setState({dogStairsMoreShow: !this.state.dogStairsMoreShow});
                        }}>
                            Click to see more Dog Stairs pictures
                    </button>
                </div>
                {this.state.dogStairsMoreShow ? (
                    <>
                        <DogStairsMore />
                        <button style={seeMoreButton} onClick={() => {
                            this.setState({ dogStairsMoreShow: !this.state.dogStairsMoreShow });
                        }}>
                            Close
                        </button>
                    </>)
                    : <></>}

                <div style={{ width: '77%', color: 'white' }}>
                    <hr></hr>
                </div>
                
                <h2>Ratchet Strap Roller</h2>
                <p style={{margin:"0px", width:"77%"}}>This was another case of a quick solution to an annoying problem. I like my ratchet straps rolled up, and there wasn't a quick way to do it. Now there is.</p>
                <div style={row}>
                    <img style={halfImage} src={RS1} alt="RS1" />
                    <div style={imageSeparator}></div>
                    <img style={halfImage} src={RS2} alt="RS2" />
                </div>
                <div style={row}>
                    <img style={halfImage} src={RS3} alt="RS3" />
                    <div style={imageSeparator}></div>
                    <img style={halfImage} src={RS4} alt="RS4" />
                </div>

                <div style={{ width: '77%', color: 'white' }}>
                    <hr></hr>
                </div>
                
                <h2>Some SolidWorks Designs</h2>
                <p>A few highlights. I have many, many more designs.</p>
                <div style={row}>
                    <img style={halfImage} src={SW1} alt="SW1" />
                    <div style={imageSeparator}></div>
                    <img style={halfImage} src={SW2} alt="SW2" />
                </div>
                <div style={{display:"flex", width:'77%', justifyContent:"center", textAlign:"center", marginBottom:"20px"}}>
                    <p style={{margin:"0px", width:"35%"}}>A bedframe with concealed drawers and a slot for a dog bed.</p>
                    <div style={imageSeparator}></div>
                    <p style={{margin:"0px", width:"35%"}}>My design for a simple lift top coffee table. I did not design in the mechanism, but did add rods so the assembly can move in Solidworks.</p>                    
                </div>
                <div style={row}>
                    <img style={halfImage} src={SW3} alt="SW3" />
                    <div style={imageSeparator}></div>
                    <div style={halfImage}>
                    <Player
                        playsInline
                        poster="/assets/poster.png"
                        src={SW4}
                        />
                    </div>
                </div>
                <div style={{display:"flex", width:'77%', justifyContent:"center", textAlign:"center", marginBottom:"20px"}}>
                    <p style={{margin:"0px", width:"35%"}}>A V8 engine sketched up for a class project.</p>
                    <div style={imageSeparator}></div>
                    <p style={{margin:"0px", width:"35%"}}>Demonstrating some movement.</p>                    
                </div>

                <div style={{ width: '77%', color: 'white' }}>
                    <hr></hr>
                </div>
                
                <h2>Home Cat Projects</h2>
                <div style={row}>
                    <img style={halfImage} src={C1} alt="C1" />
                    <div style={imageSeparator}></div>
                    <img style={halfImage} src={C3} alt="C3" />
                </div>
                <div style={{display:"flex", width:'77%', justifyContent:"center", textAlign:"center", marginBottom:"20px"}}>
                    <p style={{margin:"0px", width:"35%"}}>A "Catio" so our cats can sunbathe.</p>
                    <div style={imageSeparator}></div>
                    <p style={{margin:"0px", width:"35%"}}>I planned on building this cat tree for our apartment, but then we bought a house, where I can just put shelves on the walls.</p>                    
                </div>
                <div style={row}>
                    <button style={seeMoreButton} onClick={() => {
                            this.setState({catsMoreShow: !this.state.catsMoreShow});
                        }}>
                            Click to see more Cat Project pictures
                    </button>
                </div>
                {this.state.catsMoreShow ? (
                    <>
                        <CatsMore />
                        <button style={seeMoreButton} onClick={() => {
                            this.setState({ catsMoreShow: !this.state.catsMoreShow });
                        }}>
                            Close
                        </button>
                    </>)
                    : <></>}

                <div style={{ width: '77%', color: 'white' }}>
                    <hr></hr>
                </div>
            </div>
        );
    }
}